import { createAction, props } from "@ngrx/store";
import { NccCreationRequest, NccData, NccEditRequest, NccSearchFilter } from "../../models/ncc.model";
import { HttpErrorResponse } from "@angular/common/http";

export const nccCreationRequest = createAction(
        '[Ncc] Ncc creation request', props<{ nccCreationRequest: NccCreationRequest }>());

export const nccCreationSuccess = createAction(
        '[Ncc] Ncc creation success', props<{ createdNcc: NccData }>());

export const nccCreationFail = createAction(
        '[Ncc] Ncc creation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const nccEdit = createAction(
        '[Ncc] Ncc edit', props<{ nccToEdit: NccData }>());

export const nccCopy = createAction(
        '[Ncc] Ncc copy', props<{ nccToCopy: NccData }>());

export const nccEditSave = createAction(
        '[Ncc] Ncc edit save', props<{ nccToEdit: NccEditRequest }>());

export const nccEditSaveSuccess = createAction(
        '[Ncc] Ncc edit save success', props<{ editedNcc: NccData }>());

export const nccEditSaveFail = createAction(
        '[Ncc] Ncc edit fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const nccView = createAction(
        '[Ncc] Ncc view', props<{ nccToView: NccData }>());

export const nccSearchRequest = createAction(
        '[Ncc] Ncc search request', props<{ searchFilter: NccSearchFilter }>());

export const nccSearchAllRequest = createAction(
        '[Ncc] Ncc search all request');

export const nccSearchSuccess = createAction(
        '[Ncc] Ncc search success', props<{ searchResult: NccData[] }>());

export const nccSearchDataReset = createAction(
        '[Ncc] Ncc search data reset');

export const nccSearchFail = createAction(
        '[Ncc] Ncc search fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const nccDeleteRequest = createAction(
        '[Ncc] Ncc delete request', props<{ nccId: number }>());

export const nccDeleteSuccess = createAction(
        '[Ncc] Ncc delete success', props<{ nccId: number }>());

export const nccDeleteFail = createAction(
        '[Ncc] Ncc delete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());